import React, { useState, useEffect } from 'react';
import { Search, FileText, CheckCircle, Shield } from 'lucide-react';

const ProcessSlider = () => {
  const [activeStep, setActiveStep] = useState(0);

  const steps = [
    {
      icon: Search,
      title: 'Comprehensive Search',
      description: 'We conduct a thorough trademark search to ensure your brand name is available and identify potential conflicts.',
    },
    {
      icon: FileText,
      title: 'Application Preparation',
      description: 'Our experts prepare and file your trademark application with accurate documentation and proper classification.',
    },
    {
      icon: Shield,
      title: 'Review, Filing & Protection',
      description: 'We review your application for accuracy, submit it to the USPTO for official processing, and once approved, your trademark is officially registered, providing legal protection for your brand nationwide.',
    },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveStep((prev) => (prev + 1) % steps.length);
    }, 4000);

    return () => clearInterval(timer);
  }, [steps.length]);

  return (
    <div className="relative" data-testid="process-slider">
      {/* Desktop view */}
      <div className="hidden md:grid grid-cols-3 gap-8">
        {steps.map((step, index) => {
          const Icon = step.icon;
          return (
            <div
              key={index}
              onClick={() => setActiveStep(index)}
              className={`bg-white rounded-2xl p-6 cursor-pointer border-2 ${
                activeStep === index
                  ? 'border-indigo-500 shadow-xl scale-105 bg-gradient-to-br from-indigo-50 to-purple-50'
                  : 'border-gray-200 shadow-md hover:border-indigo-300'
              }`}
              style={{ transition: 'all 0.3s ease' }}
              data-testid={`process-step-${index}`}
            >
              <div
                className={`w-16 h-16 rounded-full flex items-center justify-center mb-4 ${
                  activeStep === index ? 'bg-gradient-to-br from-indigo-500 to-purple-600' : 'bg-indigo-100'
                }`}
              >
                <Icon className={activeStep === index ? 'text-white' : 'text-indigo-600'} size={32} />
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: 'var(--text-dark)' }}>
                {step.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">{step.description}</p>
            </div>
          );
        })}
      </div>

      {/* Mobile slider view */}
      <div className="md:hidden">
        <div className="bg-white rounded-2xl p-8 shadow-xl">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              index === activeStep && (
                <div key={index} data-testid={`process-mobile-step-${index}`}>
                  <div className="w-20 h-20 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center mb-6 mx-auto">
                    <Icon className="text-white" size={40} />
                  </div>
                  <h3 className="text-2xl font-bold mb-4 text-center" style={{ color: 'var(--text-dark)' }}>
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-center leading-relaxed">{step.description}</p>
                </div>
              )
            );
          })}
        </div>

        {/* Navigation dots */}
        <div className="flex justify-center mt-6 space-x-2">
          {steps.map((_, index) => (
            <button
              key={index}
              onClick={() => setActiveStep(index)}
              className={`w-3 h-3 rounded-full transition-all ${
                index === activeStep ? 'bg-indigo-600 w-8' : 'bg-gray-300'
              }`}
              data-testid={`process-dot-${index}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProcessSlider;